import { create } from 'zustand';

export const useDisposalStore = create((set) => ({
    items: [],
    loading: false,
    error: null,
    selectedItem: null,
    columnFilters: {},
    uniqueValues: {},
    paginationData: {
        currentPage: 1,
        itemsPerPage: 10,
        totalItems: 0,
        totalPages: 0,
    },
    isFormOpen: false,
    isEditMode: false,
    isDeleteDialogOpen: false,
    itemToDelete: null,
    records: [],
    recordsLoading: false,

    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    clearError: () => set({ error: null }),
    setItems: (items) => set({ items }),
    setSelectedItem: (selectedItem) => set({ selectedItem }),
    setColumnFilters: (columnFilters) => set({ columnFilters }),
    setUniqueValues: (uniqueValues) => set({ uniqueValues }),
    setPaginationData: (data) => set((state) => ({
        paginationData: { ...state.paginationData, ...data },
    })),
    setRecords: (records) => set({ records }),
    setRecordsLoading: (recordsLoading) => set({ recordsLoading }),

    openCreateForm: () => set({ isFormOpen: true, isEditMode: false, selectedItem: null, error: null }),
    openEditForm: (item) => set({ isFormOpen: true, isEditMode: true, selectedItem: item, error: null }),
    closeForm: () => set({ isFormOpen: false, selectedItem: null, error: null }),
    openDeleteDialog: (item) => set({ isDeleteDialogOpen: true, itemToDelete: item, error: null }),
    closeDeleteDialog: () => set({ isDeleteDialogOpen: false, itemToDelete: null, error: null }),
}));
